(ns manage.feed-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/List$default" :as List]
            ["@mui/material/ListItem$default" :as ListItem]
            ["@mui/material/ListItemText$default" :as ListItemText]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridActionsCellItem]]
            ["src/svg/inform/cross-square.svg$default" :as ErrorIcon]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            ["src/svg/inform/plus.svg$default" :as Plus]
            [cljs-bean.core :as bean]
            [clojure.string :as str]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-query]]
            [common.resource.query.feed-importer :as fq]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal import-problems :table.feed/import-problems
  [{:keys [details]}]
  ($ modal-v2 {:title "Import problems"}
     ($ Stack
        ($ List
           (for [item details]
             ($ ListItem
                ($ ListItemText
                   {:primary (:title item)
                    :secondary (:details item)})))))))

(defmodal latest-import-details :product-imports/latest-import-info
  [{:keys [feed-id]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {{:keys [data]} :data} (use-query (fq/latest-product-feed-import-errors-query advertiser-id feed-id))
        summary (-> data :details first)
        aggregated-errors (-> data :aggregated-errors)
        has-errors? (pos? (count aggregated-errors))
        column-name-mapping (->> [:number-of-errors "Number of errors"
                                  :total-rows-in-feed "Total rows in the feed"
                                  :number-of-products-inserted "Number of products inserted"
                                  :number-of-new-products-inserted "Number of new products inserted"
                                  :number-of-products-after-import "Number of products after import"
                                  :number-of-products-before-import "Number of products before import"] (partition 2))]
    ($ modal-v2
       {:title (if has-errors? "Import errors" "Import details")
        :icon (when has-errors?
                ($ SvgIcon
                   {:color "warning"
                    :component AlertIcon}))
        :footer ($ Button {:variant "contained"
                           :color "warning"
                           :on-click #(rf/dispatch [:table.feed/get-latest-import-file feed-id])}
                   "Download full list")}
       ($ Stack {:sx #js {:minWidth 580 :minHeight 320}}
          ($ List
             (for [[meta-key meta-label] column-name-mapping]
               (let [meta-value (get summary meta-key 0)]
                 ($ Stack {:key meta-key}
                    ($ ListItem {:key meta-key :disable-padding true}
                       ($ ListItemText {:primary meta-label
                                        :secondaryTypographyProps #js {:color (if (and (= meta-key :number-of-errors) (> meta-value 0))
                                                                                "red"
                                                                                "green")}
                                        :secondary meta-value}))
                    ($ Divider {:component "li"})))))
          (for [error aggregated-errors]
            ($ Stack
               {:key (str (:row-numbers error) (:message error) (:columns-affected error))
                :direction "row"
                :gap 1
                :p 2
                :align-items "center"}
               ($ ErrorIcon)
               ($ Stack
                  ($ Typography {:variant "h4"}
                     (if-let [row-numbers (:row-numbers error)]
                       (str "ROW NUMBERS: " row-numbers)
                       ""))
                  ($ Typography {:variant "h4"}
                     (if-let [columns-affected (seq (:columns-affected error))]
                       (str "COLUMN(S): " (str/join ", " columns-affected))
                       ""))

                  ($ Typography (:message error)))))))))

(defui render-name-column [{:keys [feed]}]
  (let [{:keys [name url]} feed]
    ($ Stack
       ($ Typography
          {:noWrap true}
          name)
       ($ Typography
          {:fontSize "sm"
           :sx #js {:color "text.disabled"}}
          url))))

(defui render-status-column [{:keys [status last-run-details id]}]
  (let [import-info-available? (-> last-run-details first :number-of-errors)
        open-info-fn #(if import-info-available?
                        (rf/dispatch [:modal/open {:id :product-imports/latest-import-info
                                                   :props {:feed-id id}}])
                        (rf/dispatch [:table.feed/show-import-problems last-run-details]))]
    ($ Stack
       {:direction "row"
        :alignItems "center"
        :gap 1}
       (when status
         ($ Chip
            (cond-> {:label (if (#{"succeeded with warning(s)"} status) "warning" status)}
              import-info-available? (assoc :onClick open-info-fn))))
       (when (#{"failed" "succeeded with warning(s)"} status)
         ($ Tooltip {:placement "top"
                     :title "Show problems"}
            ($ IconButton
               {:color "warning"
                :on-click open-info-fn}
               ($ Icon "report_problem")))))))

(defn get-actions [^js o]
  (let [row (.-row o)]
    (to-array [($ GridActionsCellItem
                  {:onClick #(do (js/console.log  o)
                                 (rf/dispatch [:form.feed-importer/open row]))
                   :icon ($ Icon "create")
                   :label "Edit configuration"
                   :showInMenu true})
               ($ GridActionsCellItem
                  {:onClick #(rf/dispatch [:form.feed-importer/trigger row])
                   :icon ($ Icon "file_download")
                   :label "Run manual import"
                   :showInMenu true})])))

(def ^:private columns-data
  #js [#js {:field "name"
            :headerName "Name"
            :type "string"
            :flex 2
            :minWidth 250
            :maxWidth 600
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:name row))
            :renderCell (fn [^js params]
                          ($ render-name-column {:feed (.-row params)}))}

       #js {:field "state"
            :headerName "Status"
            :type "singleSelect"
            :minWidth 120
            :valueOptions #js ["succeeded" "failed" "succeeded with warning(s)" "running"]
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:state row))
            :renderCell (fn [^js params]
                          (let [row (.-row params)]
                            ($ render-status-column {:status (:state row)
                                                     :last-run-details (:last-run-details row)
                                                     :id (:id row)})))}

       #js {:field "last-run-at"
            :headerName "Last run"
            :type "dateTime"
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (some-> (:last-run-at row) js/Date.))}

       #js {:field "next-run-at"
            :headerName "Next run"
            :type "dateTime"
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (some-> (:next-run-at row) js/Date.))}

       #js {:field "updated-at"
            :headerName "Last modified"
            :type "dateTime"
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (some-> (:updated-at row) js/Date.))}

       #js {:field "actions"
            :type "actions"
            :column-type "actions"
            :width 16
            :getActions get-actions}])

(def Toolbar
  (uix/as-react
   (fn [{:keys [quick-filter-props feed-type]}]
     (let [adsets2-edit-allowed? (use-subscribe [:resource.user/allowed? "adsets2.edit"])]
       ($ dg/grid-toolbar {:quick-filter-props quick-filter-props}
          (when adsets2-edit-allowed?
            (case feed-type
              :lookup ($ Button
                         {:onClick #(rf/dispatch [:form.feed-importer/open])
                          :variant "contained"
                          :startIcon ($ Plus)
                          :data-testid "create-feed-button"}
                         "New dynamic feed")
              :product ($ Button
                          {:onClick #(rf/dispatch [:form.feed-importer/open])
                           :variant "contained"
                           :startIcon ($ Plus)
                           :data-testid "create-feed-button"}
                          "New importer"))))))))

(defui table [{:keys [feed-type]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        initial-pagination-model #js {:page 0 :pageSize 10}
        initial-sort-model #js [#js {:field "updated-at" :sort "desc"}]

        table-query-fn (uix/use-callback
                        (fn [{:keys [^js filter-model ^js sort-model ^js pagination-model]}]
                          (let [term (str/join " " (.-quickFilterValues filter-model))
                                filters (cond-> []
                                          (seq term) (conj {:field "name" :value term})
                                          (some? feed-type) (conj {:field "type" :value feed-type}))]
                            (fq/feed-importers-query
                             {:advertiser-id advertiser-id
                              :filters filters
                              :sort (bean/->clj (first sort-model))
                              :page-size (.-pageSize pagination-model)})))
                        [advertiser-id feed-type])

        server-table-props (dg/use-server-table-props
                            {:initial-pagination-model initial-pagination-model
                             :initial-sort-model initial-sort-model
                             :table-query-fn table-query-fn
                             :prevent-loading-on-refetch true
                             :disable-default-transform true
                             :transform-response-fn :items
                             :get-row-count-fn (comp :total :meta)})

        get-row-id (uix/use-callback (fn [row]
                                       (:id row))
                                     [])]
    ($ DataGridPremium
       (merge server-table-props
              {:columns columns-data
               :getRowId get-row-id
               :disableRowSelectionOnClick true
               :slots #js {:toolbar Toolbar}
               :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                               :toolbar #js {:quick-filter-props {:inputProps #js {:data-testid "searchInput"}}
                                             :feed-type feed-type}}
               :data-testid "feed-table"
               :sx #js {:maxHeight "70rem"}}))))
